// admin — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {};

export const fr = {};
